import { cn } from '@strivelabs/ui-core/lib/utils';
import { PersonAvatar } from '@/components/common/PersonAvatar';
import type { AssignedUser } from '@/types/task';

interface TaskPersonProps {
  person: Pick<AssignedUser, 'display_name' | 'image_url'> | null;
  /** Shown in place of a name when nobody holds the role. */
  empty?: string;
  /** The table's property-cell scale (artifact `--prop-avatar`): a 16px
   *  avatar on the shared 7px icon-to-text gap. Menus and the panel keep the
   *  larger default. */
  compact?: boolean;
}

/** A person's avatar and name, or an em dash when the role is empty. */
export const TaskPerson = ({ person, empty = '—', compact = false }: TaskPersonProps) => {
  if (!person) {
    return <span className="text-[#B7B4AC]">{empty}</span>;
  }

  return (
    <span className={cn('inline-flex min-w-0 items-center', compact ? 'gap-[7px]' : 'gap-2')}>
      <PersonAvatar person={person} className={compact ? 'size-4 text-[8px]' : undefined} />
      <span className="truncate text-[13.5px] text-[#696969]">{person.display_name}</span>
    </span>
  );
};
